import Keycloak from 'keycloak-js';

const keycloakConfig = {
  url: import.meta.env.VITE_KEYCLOAK_URL || 'http://localhost:8180',
  realm: 'rfo',
  clientId: 'rfo-frontend',
};

const keycloak = new Keycloak(keycloakConfig);

export default keycloak;
